import styles from './DropDownMenuItem.module.scss';
import * as icons from 'assets/icons';
import cx from 'classnames';
import { Icon, RadioButton, Text } from 'components';

type Props = {
  name: string;
  isTouchDevice: boolean;
  onClick(): void;
  iconName?: keyof typeof icons;
  warn?: boolean;
  radio?: boolean;
  checked?: boolean;
};

export const DropDownMenuItem = ({ name, iconName, warn = false, isTouchDevice, onClick, radio, checked }: Props) => {
  return (
    <div
      className={cx(styles.container, {
        [styles.isTouchDevice]: isTouchDevice,
        [styles.isTouchDeviceWithRadio]: isTouchDevice && radio,
      })}
      onClick={onClick}>
      {iconName && <Icon name={iconName} className={styles.icon} />}
      {radio && <RadioButton inputName={name} defaultChecked={checked} />}
      <Text type={isTouchDevice ? 'subtitle2' : 'body2'} className={cx(styles.itemName, { [styles.warn]: warn })}>
        {name}
      </Text>
    </div>
  );
};
